import { Box, Center, Stack, useBreakpointValue } from '@chakra-ui/react'

import { getArticleUrl } from '@/client/services/url/faq'

import {
  COLLEGE_PARTNER_DETAILS,
  PORTFOLIO_COLLEGE_PARTNERS,
} from '@/components/Partners/constants'
import PublicImage from '@/components/PublicImage/PublicImage'
import Card from '@/components/Worlds/UI/Card'

import PartnerLogosWrap from './PartnerLogosWrap'

export default function CollegePartnerImage() {
  const scaleMultiplier = useBreakpointValue({ base: 0.6, sm: 0.45 })
  const numCollegePartners = useBreakpointValue({ base: 7, sm: 9, lg: 11 })

  return (
    <Stack direction="column" spacing={4}>
      <Center>
        <Box
          position="relative"
          pl={{ base: '68px', sm: '88px' }}
          pt={{ base: '24px', sm: '52px' }}
          width="100%"
        >
          <PublicImage
            src="/blank_portfolio.png"
            alt="Schoolhouse Portfolio"
            maxWidth="85%"
            width="400px"
            left="0px"
            top="0px"
            position="absolute"
            zIndex={0}
          />
          <Card width="100%" zIndex={1} position="relative">
            <PartnerLogosWrap
              partners={PORTFOLIO_COLLEGE_PARTNERS.slice(0, numCollegePartners).map(
                partner => COLLEGE_PARTNER_DETAILS[partner]
              )}
              spacing="0px"
              scaleMultiplier={scaleMultiplier}
              plusMoreHref={getArticleUrl('what-is-a-portfolio')}
            />
          </Card>
        </Box>
      </Center>
    </Stack>
  )
}
